<template>
    <div class="flex flex-col">
        <h2 class="text-2xl md:text-4xl font-semibold mb-6">Patient Overview: Medical History</h2>

        <img
            src="@/assets/img/graphics/transplant/medical-history-desktop.svg"
            alt="Patient journey"
            class="hidden md:block"
        />
        <img
            src="@/assets/img/graphics/transplant/medical-history-mobile.svg"
            alt="Primary Clinical Manifestations in PH1"
            class="md:hidden self-center"
        />
    </div>
</template>
